<script setup>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()

// Not shown on login / register / error pages (blank layout)
const isVisible = computed(() => route.meta?.layout !== 'blank')

// Keep the card title just below the sticky navbar
const NAVBAR_OFFSET = 90

const scrollToList = () => {
  const el = document.getElementById('sales-order-list')
  if (!el)
    return false
  window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - NAVBAR_OFFSET, behavior: 'smooth' })

  return true
}

const goToSalesOrderList = async () => {
  if (route.path !== '/master/jobcard')
    await router.push({ path: '/master/jobcard', query: { scroll: 'sales-order-list' } })

  // wait for the list card to render, then scroll again once the list has loaded and moved the layout
  let tries = 0
  const timer = setInterval(() => {
    tries++
    if (scrollToList() || tries > 30) {
      clearInterval(timer)
      setTimeout(scrollToList, 600)
    }
  }, 100)
}
</script>

<template>
  <VBtn
    v-if="isVisible"
    icon
    density="comfortable"
    color="primary"
    class="sales-order-list-btn d-print-none"
    title="Sales Order List"
    @click="goToSalesOrderList"
  >
    <VIcon
      size="22"
      icon="tabler-list-details"
    />
  </VBtn>
</template>

<style lang="scss">
.sales-order-list-btn {
  position: fixed !important;

  // Above page content, below the navbar (11), nav drawer/overlay (11-12), page loaders (999) and dialogs
  z-index: 10;
  inset-block-end: calc(5% + 48px);
  inset-inline-end: 25px;
}
</style>
